function AvailabilityButton({
    userId,
    userName,
    className = '',
    size = 'small',
    variant = 'outline',
    disabled = false,
}) {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (disabled) return;

        const event = new CustomEvent('openAvailabilityCalendar', {
            detail: { userId, userName },
        });
        window.dispatchEvent(event);
    };

    const getSizeClass = () => {
        switch (size) {
            case 'small': return 'btn-sm';
            case 'large': return 'btn-lg';
            case 'icon':  return 'btn-icon';
            default: return '';
        }
    };

    const getVariantClass = () => {
        switch (variant) {
            case 'secondary': return 'btn-secondary';
            case 'outline':   return 'btn-outline';
            default: return 'btn-primary';
        }
    };

    return (
        <button
            onClick={handleClick}
            disabled={disabled}
            className={`base-btn availability-btn ${getSizeClass()} ${getVariantClass()} ${className}`}
            title={`Check ${userName}'s availability`}
            aria-label={`Check ${userName}'s availability`}
        >
            {/* Calendar icon */}
            <svg
                className="availability-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
            {size !== 'icon' && <span className="btn-label">Check Dates</span>}
        </button>
    );
}

export default AvailabilityButton;
